import Reveal from 'reveal.js';
import store from 'store';

//Обнуляем данные при открытии документа
//сробатывает только при открытии презентации,
//во фреймах этого вызова нет
store.clearAll();

Reveal.initialize({
  history: true,
  controls: true,
  progress: true,
  center: true,
  slideNumber: true,
  margin: 0.0,
  transition: 'slide',
  touch: true,
  // based on 1280x800
  width: 1280,
  height: 800,

  // Optional libraries used to extend on reveal.js
  dependencies: [],
  // More info https://github.com/hakimel/reveal.js#dependencies
});

/**При переходе на третий слайд, перезагружаем фрейм
 * и отсылаем данные в базу
 * TODO: Данные отсылаются столько раз, сколько раз переходим на это слайд
 * можно сделать проверку изменились ли данные и только тогда их отпровлять
 */
Reveal.addEventListener(
  'reloadFrame',
  function() {
    let reosorbilaktData = store.get('#reosorbilakt-touch');
    let nacl = store.get('#nacl-touch');
    //document.getElementById('reloadFrame').contentWindow.location.reload(true);
    document.getElementById('reloadFrame').src += '';
    getDataConsoleLog(nacl, 'Глюкоза');
    getDataConsoleLog(reosorbilaktData, 'Реосорбилакт');
  },
  false
);

function getDataConsoleLog(data, name) {
  for (var item in data) {
    console.log('[' + name + ']' + data[item].axis + '=' + data[item].value);
  }
}

/**Поп-ап описание на третьем слайде
 *
 */
var descriptionBottom = document.querySelectorAll('.descriptions .description .bottom');
var descriptionСontent = document.querySelectorAll('.descriptions .description .content');
Array.prototype.forEach.call(descriptionBottom, function(el, i) {
  el.addEventListener('click', function() {
    toggleEl(this.parentNode.querySelectorAll('.content')[0], 'open');
  });
});

function toggleEl(el, className) {
  for (var i = 0; i < descriptionСontent.length; i++) {
    if (el !== descriptionСontent[i]) {
      descriptionСontent[i].classList.remove(className);
    }
  }

  if (el.classList) {
    el.classList.toggle(className);
  } else {
    var classes = el.className.split(' ');
    var existingIndex = classes.indexOf(className);

    if (existingIndex >= 0) {
      classes.splice(existingIndex, 1);
    } else {
      classes.push(className);
    }

    el.className = classes.join(' ');
  }
}

//
if (typeof Android != 'undefined') {
  Android.disablePaging();
}
